var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCsv = function SvgCsv(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    fillRule: "evenodd",
    d: "M10 2.241V.001A62.344 62.344 0 0 0 9.463 0H7.357C6.273 0 5.4 0 4.691.058c-.728.06-1.369.185-1.961.487A5 5 0 0 0 .545 2.73C.243 3.322.117 3.963.058 4.691 0 5.4 0 6.273 0 7.357v7.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C5.4 22 6.273 22 7.357 22h3.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C18 16.6 18 15.727 18 14.643V8.537L17.999 8h-2.24c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C10 3.71 10 3.046 10 2.242ZM5 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H5Zm0 4a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M12 2.2V.283c.333.117.654.269.956.454.505.31.93.735 1.544 1.348L15.913 3.5c.615.614 1.04 1.04 1.35 1.545.185.302.337.623.454.956H15.8c-.857 0-1.439 0-1.889-.037-.438-.036-.663-.101-.819-.18a2 2 0 0 1-.874-.875c-.08-.156-.145-.38-.18-.819C12 3.639 12 3.057 12 2.2Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCsv);
export default ForwardRef;